import { render } from "./ylyVideoManage.vue?vue&type=template&id=383c7bfe&scoped=true"
import script from "./ylyVideoManage.vue?vue&type=script&lang=js"
export * from "./ylyVideoManage.vue?vue&type=script&lang=js"

import "./ylyVideoManage.vue?vue&type=style&index=0&id=383c7bfe&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c7bfe"]])

export default __exports__